module.exports = __webpack_public_path__ + "static/footer_badge-4f71a639e5d290078949825cd6b80fee.png";